module.exports = __webpack_public_path__ + "img/logo_square_XS.42a4295b.png";